module.exports = __webpack_public_path__ + "static/media/400044_01.6e51ed0e.png";